<template>
  <div>
    <div @click="close" class="close icon-back" v-show="closeBtn"></div>
    <router-link to="/search">
      <gm-search disabled :placeholder="$t('search_placeholder')"></gm-search>
    </router-link>
    <gm-welcome></gm-welcome>
    <problem-source></problem-source>
    <gm-banner></gm-banner>
    <gm-list
      v-if="mc"
      :list="list"
      :showArticle="false"
      style="margin-bottom: 10px"
    ></gm-list>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { compareVersion } from '@duoke/tools'
import native, { isMC } from '@/utils'
import GlobalHeader from '@/components/GlobalHeader'
import GmSearch from '@/components/Search'
import GmWelcome from '../components/Welcome'
import GmBanner from '../components/Banner'
import ProblemSource from '../components/ProblemSource'
import GmList from '../components/List'

const base = {
  21: '2.6.0', // IOS Air-黑端企业版
  31: '2.6.0', // IOS Air-黑端标准版
  22: '2.9.0', // IOS Air-红端企业版
  32: '2.9.0', // IOS Air-红端标准版
  41: '2.4.0', // Android Air-黑端
  42: '2.5.0', // Android Air-红端
}
// const basic = { name: '意见反馈', native: { type: 'bugtraceFeedback' } }
const basic = { name: '意见反馈', url: '/feedback' }
const { appInfo } = native

export default {
  name: 'home',
  components: {
    GlobalHeader,
    GmSearch,
    GmWelcome,
    GmBanner,
    ProblemSource,
    GmList,
  },
  data() {
    return {
      closeBtn: true,
      list: [basic],
      title: i18n.t('novice_tutorial'),
    }
  },
  mounted() {
    if (!isMC()) {
      this.getList()
    }
    this.$store.dispatch('requestBannerList')
    this.$store.dispatch('requestProblemSource')
    this.closeBtn = !!(appInfo.key || appInfo.token)
  },
  activated() {
    setTimeout(() => {
      this.closeBtn = !!(appInfo.key || appInfo.token)
    }, 300)
  },
  deactivated() {
    this.closeBtn = false
  },
  methods: {
    close() {
      window.location.href = 'obj-c::closeWindows'
    },
    getList() {
      const { projId, appVersion } = native.appInfo || {}
      if (projId) {
        if (
          !projId ||
          !appVersion ||
          !base[projId] ||
          !compareVersion(appVersion, base[projId])
        ) {
          this.list = [basic]
        } else {
          this.list = [
            { name: '意见反馈', native: { type: 'bugtraceFeedback' } },
          ]
        }
      } else {
        setTimeout(this.getList, 100)
      }
    },
  },
  computed: {
    mc() {
      return !isMC() && !!(appInfo.key || appInfo.token)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../style/func.scss';

.light .close {
  color: #000;
}
.close {
  position: fixed;
  left: 0;
  top: 0;
  width: px2rem(40px);
  color: #fefefe;
  height: px2rem(40px);
  font-size: px2rem(17px);
  text-align: center;
  line-height: px2rem(42px);
  z-index: 10;
}
.iPhone {
  .close {
    top: 20px;
    top: constant(safe-area-inset-top);
    top: env(safe-area-inset-top);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/views/HomeView.vue